module.exports = __webpack_public_path__ + "img/hk10x-cover1.57a11ac8.png";